<template>
	<el-tabs v-model="activeName" @tab-click="handleClick">
		<el-tab-pane label="Zaps" name="zaps">
            <zaps-table :options="options"></zaps-table>
		</el-tab-pane>
		<el-tab-pane label="Zap Reports" name="reports">
            <zap-logs></zap-logs>
		</el-tab-pane>
	</el-tabs>
</template>

<script>

    import ZapsTable from "@shared/components/Zapier/ZapsTable"
    import ZapLogs from "@shared/components/Zapier/ZapLogs"

	export default {
		name: "ZapierTabs",
        props: {
            options: {
                required: true
            }
        },
		components: {
            ZapsTable,
            ZapLogs
		},
		data() {
			return {
				activeName: "zaps",
			}
		},
		methods: {
			handleClick(tab, event) {

			},
		},
	}
</script>

<style lang="scss" scoped>

	.el-tabs__header {
		margin: 0 0 2rem !important;
	}

</style>
